import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import { CardService } from '../../view/card/card.service';

@Component({
  selector: 'app-inputType-rating',
  templateUrl: './inputType-rating.component.html',
  styleUrls: ['./inputType-rating.component.scss']
,  standalone: false
})
export class InputTypeRatingComponent implements OnInit, OnDestroy, OnChanges {
  @Input() showName?: boolean = true;
  @Input() IsReadOnly?: boolean = false;
  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() isEditing: boolean;

  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  isConditionIsTrue: boolean;
  @Output() childQuestion: EventEmitter<QuestionViewModel> = new EventEmitter<QuestionViewModel>();
  @Output() inputChange: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  starRating: any;
  maxStars: number = 5;
  userInputRate: number = 0;
  private resetSubscription: Subscription;

  constructor(private cardService: CardService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question'] && changes['question'].currentValue) {
      const currentQuestion = changes['question'].currentValue;
      this.question = { ...currentQuestion }; // Create a new reference to trigger change detection
      if (this.question.responseText && this.question.responseText.length > 0) {
        let res = this.question.responseText.split('of');
        if (res) {
          this.starRating = parseInt(res[0].trim());
          this.userInputRate = parseInt(res[0].trim());
          this.maxStars = parseInt(res[1].trim());
        }
      }
      else {
        this.userInputRate = 0;
        this.starRating = 0;
      }
      
      this.CheckValidations();
      this.childQuestion.emit(this.question);      
    }
  }
  ngDoCheck() {
    if (this.question.errorMessage) {
      this.CheckValidations();
    }
  }
  ngOnDestroy() {
    if (this.resetSubscription) {
      this.resetSubscription.unsubscribe();
    }
  }
  clearRating() {
    this.userInputRate = 0; this.starRating = 0;
  }
  ngOnInit() {
    this.question["IsValid"] = true;
    this.validationerrormessage = [];
    this.errormgvisible = false;

    this.resetSubscription = this.cardService.resetRating$.subscribe(() => {
      this.clearRating();
    });
    

    if (this.question.responseText != undefined && this.question.responseText != null && this.question.responseText.length > 0) {
      let res = this.question.responseText.split('of');
      if (res) {
        this.starRating = parseInt(res[0].trim());
        this.userInputRate = parseInt(res[0].trim());
        this.maxStars = parseInt(res[1].trim());
      }

    }
    else {
      this.userInputRate = 0;
      this.starRating = 0;
    }
    if (this.question.isQuestionRequired == "Y") {
      this.isConditionIsTrue = true;
    }
    else {
      this.isConditionIsTrue = false;
    }
    this.CheckValidations();
    this.errormgvisible = false;
    this.validationerrormessage = [];
      
    
    this.checkForConsentScreen();
  }
  checkForConsentScreen() {
    if (this.question.isConsentQuestion && this.question.consentQuestionLabel != null && this.question.consentQuestionLabel.length > 0  ) {
      this.question.safeHtmlContent = this.question.consentQuestionLabel;
    }
  }

  
  CheckValidations() {
  this.errormgvisible = false;
  this.validationerrormessage = [];

  const isRequired = this.question.isQuestionRequired === "Y";
  const value = this.question["responseText"];
  const isEmpty = !value || value.trim().length === 0;

  if (isRequired && isEmpty) {
    this.question["IsValid"] = false;
    this.errormgvisible = true;
    this.validationerrormessage.push("Input is mandatory");
  } else {
    this.question["IsValid"] = true;
  }

  //this.childQuestion.emit(this.question);
}

  onClickOfStar() {

    if (this.userInputRate > 0) {
      this.question.responseText = this.userInputRate.toString() + " of " + this.maxStars.toString();
      this.CheckValidations();
    }
    this.childQuestion.emit(this.question);
    this.inputChange.emit(true);
  }


}
